import { AxiosError } from 'axios';
import { UseQueryResult } from '@tanstack/react-query';

import { useGet } from 'hooks/use-get';
import { BenchmarkDateRange } from 'views/benchmark-analytics/types/benchmark-filters.type';
import { getGrowthBenchmark, getGrowthSiteData } from '../api/growth-api';
import { GrowthResponse } from '../types/growth-series.type';

const QUERY_OPTIONS = {
  staleTime: 30 * 60 * 1000,
  gcTime: 60 * 60 * 1000,
  refetchOnWindowFocus: false,
};

export const useGrowthBenchmark = (
  globalCompanyId: string | undefined,
  dateRange: BenchmarkDateRange
): UseQueryResult<GrowthResponse, AxiosError> =>
  useGet(
    ['growthBenchmark', globalCompanyId, dateRange.from, dateRange.to],
    (context) => getGrowthBenchmark(String(context.queryKey[1]), dateRange),
    { ...QUERY_OPTIONS, enabled: !!globalCompanyId }
  );

export const useGrowthSiteData = (
  globalCompanyId: string | undefined,
  globalSiteIds: string[],
  dateRange: BenchmarkDateRange
): UseQueryResult<GrowthResponse, AxiosError> =>
  useGet(
    ['growthSiteData', globalCompanyId, dateRange.from, dateRange.to, globalSiteIds],
    () => getGrowthSiteData(String(globalCompanyId), globalSiteIds, dateRange),
    { ...QUERY_OPTIONS, enabled: !!globalCompanyId && globalSiteIds.length > 0 }
  );
